export const CASDOOR_RETURN_PATH_KEY = 'video-transcript-casdoor-return-path'

export function resolveAuthReturnPath(value: unknown) {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return '/'
  return value
}

export function saveAuthReturnPath(value: unknown) {
  if (typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(CASDOOR_RETURN_PATH_KEY, resolveAuthReturnPath(value))
}

export function consumeAuthReturnPath() {
  if (typeof sessionStorage === 'undefined') return '/'
  const value = sessionStorage.getItem(CASDOOR_RETURN_PATH_KEY)
  sessionStorage.removeItem(CASDOOR_RETURN_PATH_KEY)
  return resolveAuthReturnPath(value)
}
